import React from 'react';
import axios from "axios";
import validator from 'validator';
import { Container, useMantineTheme, Box, SimpleGrid, Card, Button, LoadingOverlay, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { useLoginContextSU } from "../../context/loginContextSU";

import { BE_API_SU_ONE, utils } from "../../utils/globalVariables";
import { regexNoSpace } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import InputComponent from "../../components/general/InputComponent";

const SUAplikasiUtilitasIndex = () => {

    const mountedRef = React.useRef(true);

    const theme = useMantineTheme();
    const { loginContextSU, handleSetLoginContextSU } = useLoginContextSU();

    const notificationId = React.useRef({
        errorGetInitData: 'SUAplikasiUtilitasIndex-1',
        errorSubmitEmailPasswordApp: 'SUAplikasiUtilitasIndex-2',
        successSubmitEmailPasswordApp: 'SUAplikasiUtilitasIndex-3',
    })

    const [data, setData] = React.useState({
        dataInitLoading: false,

        reset: {
            id: '',

            valueEmail: '',
            valueEmailError: '',

            valuePassword: '',
            valuePasswordError: '',

            submitLoading: false
        },
        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    React.useEffect(() => {
        setData(d => ({ ...d, dataInitLoading: true }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContextSU.syswebapp);

        axios({
            method: 'post',
            url: BE_API_SU_ONE + '/get_aplikasi_utilities',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, dataInitLoading: false }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({
                    ...d,
                    reset: {
                        ...d.reset,
                        id: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? response.data.data[0]['id'] : '',
                        valueEmail: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? response.data.data[0]['email'] : '',
                        valuePassword: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? response.data.data[0]['password'] : ''
                    },
                }));
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContextSU(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContextSU(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                dataInitLoading: false,
            }));

            notifications.show({
                id: notificationId.current.errorGetInitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }, [handleSetLoginContextSU, loginContextSU.syswebapp])

    const submitReset = () => {
        setData(d => ({ ...d, reset: { ...d.reset, valueEmailError: '', valuePasswordError: '' } }));

        if (validator.isEmpty(data.reset.valueEmail, { ignore_whitespace: true })) {
            setData(d => ({ ...d, reset: { ...d.reset, valueEmailError: 'Email Gmail Harus Diisi !' } }));
        } else if (!validator.isEmail(data.reset.valueEmail)) {
            setData(d => ({ ...d, reset: { ...d.reset, valueEmailError: `Format Email Tidak Valid` } }));
        } else if (validator.isEmpty(data.reset.valuePassword, { ignore_whitespace: true })) {
            setData(d => ({ ...d, reset: { ...d.reset, valuePasswordError: 'Password Harus Diisi !' } }));
        } else {
            setData(d => ({ ...d, reset: { ...d.reset, submitLoading: true } }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContextSU.syswebapp);
            formDT.append('id', data.reset.id);
            formDT.append('email', data.reset.valueEmail);
            formDT.append('password', data.reset.valuePassword);

            axios({
                method: 'post',
                url: BE_API_SU_ONE + '/update_email_password_aplikasi_su',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, reset: { ...d.reset, submitLoading: false } }));

                if (response.data.flag_status === 'isset') {
                    notifications.show({
                        id: notificationId.current.successSubmitEmailPasswordApp,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Submit Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitEmailPasswordApp,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContextSU(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContextSU(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, reset: { ...d.reset, submitLoading: false } }));

                notifications.show({
                    id: notificationId.current.errorSubmitEmailPasswordApp,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    return (
        <React.Fragment>
            <Container fluid>
                <SimpleGrid
                    cols={1}
                    spacing='sm'
                    mt='2rem'
                    breakpoints={[
                        { minWidth: 'xl', cols: 3, spacing: 'sm' },
                        { minWidth: 'lg', cols: 3, spacing: 'sm' },
                        { minWidth: 'md', cols: 2, spacing: 'sm' },
                        { minWidth: 'sm', cols: 2, spacing: 'sm' },
                        { minWidth: 'xs', cols: 1, spacing: 'sm' },
                    ]}
                >
                    <Box>
                        <Card
                            shadow=''
                            radius="sm"
                            withBorder={true}
                            pos='relative'
                            mb='2rem'

                            style={{
                                borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7],
                                backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                                overflow: 'unset',
                                cursor: 'pointer',
                            }}
                        >
                            <Card.Section p='sm'>
                                <LoadingOverlay visible={data.dataInitLoading} overlayBlur={0} />

                                <InputComponent
                                    stateId='su-reset-email-app'
                                    stateWithAsterisk={true}
                                    stateLabelFullWidth={true}
                                    stateLabel='Email Gmail Aplikasi'
                                    stateDescription=''
                                    statePlaceHolder='Email Gmail Aplikasi'
                                    stateReadOnly={false}
                                    stateMB='1.5rem'
                                    stateValue={data.reset.valueEmail}
                                    stateError={data.reset.valueEmailError}
                                    fnOnChange={(e) => setData(d => ({ ...d, reset: { ...d.reset, valueEmail: regexNoSpace(e.target.value) } }))}
                                />

                                <InputComponent
                                    stateId='su-reset-password-app'
                                    stateWithAsterisk={true}
                                    stateLabelFullWidth={true}
                                    stateLabel='Password Aplikasi Gmail'
                                    stateDescription=''
                                    statePlaceHolder='Password Aplikasi Gmail'
                                    stateReadOnly={false}
                                    stateValue={data.reset.valuePassword}
                                    stateError={data.reset.valuePasswordError}
                                    fnOnChange={(e) => setData(d => ({ ...d, reset: { ...d.reset, valuePassword: regexNoSpace(e.target.value) } }))}
                                />

                                <Text size='sm' color='dimmed' mt='1.5rem'>
                                    Email Aplikasi ini digunakan untuk kebutuhan pengiriman email pada aplikasi, seperti verifikasi reset username dan password baru untuk user pada aplikasi ini. Dan email yang digunakan adalah email gmail (Google Mail).
                                </Text>

                                <Button
                                    mt='1rem'
                                    size='xs'
                                    loading={data.reset.submitLoading}
                                    onClick={submitReset}
                                >
                                    Reset
                                </Button>
                            </Card.Section>
                        </Card>
                    </Box>
                </SimpleGrid>
            </Container>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default SUAplikasiUtilitasIndex;